import {
  AddHolidayResponse,
  // HolidayCommonResponse,
  HolidayError,
  Holiday,
  HolidayResponse,
  DeletedHoliday,
} from '@core/interface/holiday';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HolidayActions = createActionGroup({
  source: 'Holiday',
  events: {
    'Load Holidays': props<PagePayload>(),
    'Load Holidays Success': props<HolidayResponse>(),
    'Load Holidays Failure': props<HolidayError>(),
    'Add Edit Holiday': props<Holiday>(),
    'Add Holiday Success': props<AddHolidayResponse>(),
    'Update Holiday Success': props<AddHolidayResponse>(),
    'Add Holiday Failure': props<HolidayError>(),
    'Update Holiday Failure': props<HolidayError>(),
    'Delete Holiday': props<{ id: number }>(),
    'Delete Holiday Success': props<DeletedHoliday>(),
    'Delete Holiday Failure': props<HolidayError>(),
    'Reset Deleted Status': emptyProps(),
  },
});
